export enum SortingDirection {
    NONE = 'NONE', ASC = 'ASC', DESC = 'DESC',
}

export enum SortingDirectionFieldNames {
    FUNNEL_STATUS = 'funnelStatus', FUNDED_DATE = 'fundedDate', LOAN_OFFICER = 'loanOfficer', BRANCH = 'branch'
}

function getTitle(name: SortingDirectionFieldNames) {
    switch (name) {
        case SortingDirectionFieldNames.BRANCH:
            return 'Branch';
        case SortingDirectionFieldNames.FUNDED_DATE:
            return 'Funded Date';
        case SortingDirectionFieldNames.FUNNEL_STATUS:
            return 'Funnel Status';
        case SortingDirectionFieldNames.LOAN_OFFICER:
            return 'Loan Officer';
    }
}

export class Sorting {

    constructor(public value: SortingDirection,
                public fieldName: SortingDirectionFieldNames,
                public lastUpdated = new Date(Date.now()),
                public title = getTitle(fieldName)) {
    }
}